import { useMemo } from 'react';
import { Tag } from 'antd';

import { MeetingStatus } from '../utils/enums';

type Props = {
  status: MeetingStatus;
  tagText: string;
};

const MeetingStatusTag = ({ status, tagText }: Props) => {
  const tagColor = useMemo(() => {
    let color = '';
    switch (status) {
      case MeetingStatus.DRAFTED:
        color = 'orange';
        break;
      case MeetingStatus.ANNOUNCED:
        color = 'green';
        break;
      case MeetingStatus.FINISHED:
        color = 'purple';
        break;
      case MeetingStatus.CANCELED:
        color = 'default';
        break;
      default:
        break;
    }
    return color;
  }, [status]);

  return <Tag color={tagColor}>{tagText}</Tag>;
};

export default MeetingStatusTag;
